export var Domains;
(function (Domains) {
    Domains["AFG_ACCOUNTS"] = "afgAccounts";
    Domains["AFG_CUSTOMER"] = "afgCustomer";
    Domains["CUSTOMIZATION"] = "customization";
    Domains["MESSAGE_COUNT"] = "messageCount";
    Domains["RESTRICTED_DATES"] = "restrictedDates";
    Domains["BAD_WORDS"] = "badWords";
    Domains["NOTIFICATIONS"] = "notifications";
})(Domains || (Domains = {}));
//# sourceMappingURL=types.js.map